var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturingApprovalsCertificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.318 8.59326L11.328 14.2773C11.3393 14.3442 11.3299 14.413 11.3011 14.4744C11.2723 14.5359 11.2253 14.5871 11.1666 14.6211C11.1079 14.6552 11.0402 14.6705 10.9726 14.6651C10.9049 14.6596 10.8405 14.6336 10.788 14.5906L8.40135 12.7993C8.28613 12.7132 8.14617 12.6667 8.00235 12.6667C7.85853 12.6667 7.71857 12.7132 7.60335 12.7993L5.21268 14.5899C5.16023 14.6329 5.09593 14.6588 5.02835 14.6643C4.96077 14.6698 4.89313 14.6545 4.83446 14.6205C4.77579 14.5865 4.72887 14.5355 4.69996 14.4742C4.67106 14.4128 4.66154 14.3441 4.67268 14.2773L5.68202 8.59326",
    stroke: "#0066CC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33325C10.2091 9.33325 12 7.54239 12 5.33325C12 3.12411 10.2091 1.33325 8 1.33325C5.79086 1.33325 4 3.12411 4 5.33325C4 7.54239 5.79086 9.33325 8 9.33325Z",
    stroke: "#0066CC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturingApprovalsCertificationsIcon);
export default __webpack_public_path__ + "static/media/Manufacturing Approvals & Certifications-icon.d193124525a3149d766770380c1358aa.svg";
export { ForwardRef as ReactComponent };